/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React from 'react';
// useState

import { Card, Divider, Button } from 'antd';
import * as companyDisplay from '../optionsJson/company';
import Errors from './errors';

const Header = block => {
  const { data, changeMenu, validation } = block;

  const displayData = (value, location) => {
    if (companyDisplay[location][value])
      return `${companyDisplay[location][value]} `;
    return '-';
  };

  const getFldNameKey = validationArray => {
    const keys = {};
    validationArray.forEach((element, i) => {
      keys[element.fldName] = i;
    });
    return keys;
  };

  const validatationKeys = getFldNameKey(validation);
  console.log(validatationKeys);
  if (!data) {
    return <div />;
  }
  return (
    <div className="subcomponent-wrapper">
      <Card>
        <div className="subcomponent-header">Company</div>
        <div>
          <div className="inline">
            small Business and Other Business Type Representations:{' '}
            <div>
              <p>{displayData(data.sbReps, 'businessType')} </p>
            </div>
            {validatationKeys && validatationKeys.sbReps ? (
              <Errors validation={validation[validatationKeys.sbReps]} />
            ) : (
              <div />
            )}
          </div>
          <div className="inline">
            <p />

            <div>
              Disadvantaged:
              <p>
                {displayData(data.sdbEthnicType, 'disadvantagedBusiness')}{' '}
              </p>{' '}
            </div>
            <div>
              Woman Owned:
              <p>{displayData(data.wosb, 'womanOwned')} </p>{' '}
            </div>
            <div>
              Veteran Owned:
              <p>{displayData(data.vosb, 'vetranOwned')}</p>{' '}
            </div>
          </div>
          {validatationKeys && validatationKeys.vosb ? (
            <Errors validation={validation[validatationKeys.vosb]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.wosb ? (
            <Errors validation={validation[validatationKeys.wosb]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.sdbEthnicType ? (
            <Errors validation={validation[validatationKeys.sdbEthnicType]} />
          ) : (
            <div />
          )}

          <div className="inline">
            <p />
            <div>
              {' '}
              HubZone Small Business: <p>{data.hubzoneSb ? 'Yes ' : 'No'}</p>
            </div>

            <div>
              HubZone Joint Venture:
              <p> {data.hubzoneJv ? 'Yes ' : '-'} </p>
            </div>

            <div>
              HubZone Joint Venture Remarks:
              <p>{data.hubzoneJvRemarks ? 'Yes' : '-'} </p>
            </div>
          </div>
          {validatationKeys && validatationKeys.hubzoneSb ? (
            <Errors validation={validation[validatationKeys.hubzoneSb]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.hubzoneJv ? (
            <Errors validation={validation[validatationKeys.hubzoneJv]} />
          ) : (
            <div />
          )}
          {validatationKeys && validatationKeys.hubzoneJvRemarks ? (
            <Errors
              validation={validation[validatationKeys.hubzoneJvRemarks]}
            />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              Affirmative Action Compliance:{' '}
              <p>
                {displayData(data.affrmActComp, 'affirmativeActionCompliance')}
              </p>
            </div>
          </div>
          {validatationKeys && validatationKeys.affrmActComp ? (
            <Errors validation={validation[validatationKeys.affrmActComp]} />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              Previous Contracts and Compliance Reports:{' '}
              <p>{displayData(data.prevContCompRepo, 'previousContract')}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.prevContCompRepo ? (
            <Errors
              validation={validation[validatationKeys.prevContCompRepo]}
            />
          ) : (
            <div />
          )}
          <div className="inline">
            <div>
              Alternate Disputes Resolution:{' '}
              <p>{data.altDesptRes === 'A' ? 'Yes' : 'No'}</p>
            </div>
          </div>
          {validatationKeys && validatationKeys.altDesptRes ? (
            <Errors validation={validation[validatationKeys.altDesptRes]} />
          ) : (
            <div />
          )}
        </div>
        <div className="edit-button-dibbs">
          <Button
            type="primary"
            onClick={() => {
              changeMenu('company');
            }}
          >
            Edit
          </Button>
        </div>
      </Card>
      <Divider />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/reviewComponents/company.jsx